import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { ButtonText as ButtonTextComponent } from '@prisjakt/ui/button/variants';

export const SortingOptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 2;
  ${media.mediumDown`
    margin-right: auto;
  `};
  & + & {
    margin-left: ${layout.measurements.spacing100};
  }
`;

export const SortOptionsList = styled.div`
  display: flex;
  flex-direction: column;
`;

type ButtonTextProps = {
  hide?: boolean;
};

export const ButtonText = styled(ButtonTextComponent)<ButtonTextProps>(
  props => css`
    display: flex;
    align-items: center;

    ${media.smallOnly`
      display: none;
    `}
    ${props.hide &&
      css`
        display: none;
      `}
  `
);
